export default "__VITE_ASSET__D2R$x4Ja__"